// OrganizationDetailsView.js

import React from "react";
import { Text, View, Pressable } from "react-native";
import { Feather } from "@react-native-vector-icons/feather";  // https://feathericons.com/?query=
import Button from "components/Partials/Buttons";

const OrganizationDetailsView = ({customerObjState, onToggleEditOrgDetails}) => {
	const _theme = window.main.theme;
	const onClickBack = ()=>{
		window.main.lib.setCurrentView("/subscribers");
	};
	return (
		<View style={{..._theme.container,flexShrink:1,borderWidth:0,paddingVertical:14,paddingHorizontal:(_theme.responsiveKey==="phone"?10:0),maxWidth:(window.main.platform_os!=="web"?400:_theme.respWidth)}}>
			<View style={{flexDirection:"row",paddingBottom:15}}>
				<Button nativeID="backToList" type="link" ficon="arrow-left" text="Back to Subscribers List" onpress={onClickBack} style={{width:"auto",paddingLeft:0}} textStyle={{fontSize:14,lineHeight:14}} />
			</View>
			{(!customerObjState || typeof(customerObjState)!=="object" || !customerObjState.hasOwnProperty("organization_id")) &&
				<View style={{..._theme.containerLiner,flexShrink:1,marginBottom:30}}>
					<View style={{..._theme.containerTitle}}>
						<View style={{flexDirection:"row",flexGrow:1}}>
							<Text style={_theme.containerTitleText}>Missing or Invalid ID. Please go back and try again.</Text>
						</View>
					</View>
				</View>
			}
			{(!!customerObjState && typeof(customerObjState)==="object" && !!customerObjState.hasOwnProperty("organization_id")) &&
				<View style={{..._theme.containerLiner,flexShrink:1,marginBottom:30}}>
					<View style={{..._theme.containerTitle}}>
						<View style={{flexDirection:"row",flexGrow:1}}>
							<Text style={_theme.containerTitleText}>{!!customerObjState.organization_id?"Organization Details":"Edit Organization Details"}</Text>
						</View>
					</View>
					<View style={{display:"flex",flexDirection:"column",justifyContent:"flex-start",alignItems:"stretch",flexGrow:1,flexShrink:1,alignSelf:"stretch",position:"relative"}}>

						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
							<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:200}}>
								<Text style={{color:_theme.colors.mode.textColor}}>
									Organization Name:
								</Text>
							</View>
							<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
								<Text style={{color:_theme.colors.mode.textColor}}>{customerObjState.name}</Text>
							</View>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
							<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:200}}>
								<Text style={{color:_theme.colors.mode.textColor}}>
									Short Name:
								</Text>
							</View>
							<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
								<Text style={{color:_theme.colors.mode.textColor}}>{customerObjState.shortname}</Text>
							</View>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
							<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:200}}>
								<Text style={{color:_theme.colors.mode.textColor}}>
									# Locations:
								</Text>
							</View>
							<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
								<Text style={{color:_theme.colors.mode.textColor}}>{customerObjState.locations_count}</Text>
							</View>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
							<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:200}}>
								<Text style={{color:_theme.colors.mode.textColor}}>
									# Doctors:
								</Text>
							</View>
							<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
								<Text style={{color:_theme.colors.mode.textColor}}>{customerObjState.doctors_count}</Text>
							</View>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
							<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:200}}>
								<Text style={{color:_theme.colors.mode.textColor}}>
									# Techs:
								</Text>
							</View>
							<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
								<Text style={{color:_theme.colors.mode.textColor}}>{customerObjState.techs_count}</Text>
							</View>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
							<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:200}}>
								<Text style={{color:_theme.colors.mode.textColor}}>
									# Staff:
								</Text>
							</View>
							<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
								<Text style={{color:_theme.colors.mode.textColor}}>{customerObjState.staff_count}</Text>
							</View>
						</View>

						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",marginTop:50,marginBottom:20}}>
							<Text style={{color:_theme.colors.mode.textColor,fontWeight:600}}>The following are used in outgoing communications:</Text>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
							<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:200}}>
								<Text style={{color:_theme.colors.mode.textColor}}>
									Public Phone Number:
								</Text>
							</View>
							<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
								<Text style={{color:_theme.colors.mode.textColor}}>{customerObjState.public_phone}</Text>
							</View>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
							<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:200}}>
								<Text style={{color:_theme.colors.mode.textColor}}>
									Public Email Address:
								</Text>
							</View>
							<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
								<Text style={{color:_theme.colors.mode.textColor}}>{customerObjState.public_email}</Text>
							</View>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
							<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:200}}>
								<Text style={{color:_theme.colors.mode.textColor}}>
									Public Website URL:
								</Text>
							</View>
							<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
								<Text style={{color:_theme.colors.mode.textColor}}>{customerObjState.public_website}</Text>
							</View>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
							<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:200}}>
								<Text style={{color:_theme.colors.mode.textColor}}>
									Facebook URL:
								</Text>
							</View>
							<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
								<Text style={{color:_theme.colors.mode.textColor}}>{customerObjState.public_facebook}</Text>
							</View>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
							<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:200}}>
								<Text style={{color:_theme.colors.mode.textColor}}>
									Instragram URL:
								</Text>
							</View>
							<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
								<Text style={{color:_theme.colors.mode.textColor}}>{customerObjState.public_instagram}</Text>
							</View>
						</View>

						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",marginTop:50,marginBottom:20}}>
							<Text style={{color:_theme.colors.mode.textColor,fontWeight:600}}>Status Info</Text>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
							<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:200}}>
								<Text style={{color:_theme.colors.mode.textColor}}>
									Is Disabled:
								</Text>
							</View>
							<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
								<Text style={{color:_theme.colors.mode.textColor}}>{customerObjState.is_disabled ? "YES" : "No"}</Text>
							</View>
						</View>
					</View>
					<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",paddingTop:50}}>
						<Button nativeID="editOrgDetails" type="primary" ficon="check" text="Edit Organization Details" onpress={onToggleEditOrgDetails} style={{width:"auto"}} />
					</View>
				</View>
			}
		</View>
	);
};

export default OrganizationDetailsView;
